import React, { useState } from 'react';
import Container from '@material-ui/core/Container';
import './Contact.css';
import axios from 'axios';
import ContributeData from '../data/contribute_to_lkm.json';
import Select from 'react-select';
import { useMsal } from "@azure/msal-react";

function Contact() {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    let loggedInEnterpriseId = '';
    if(activeAccount)
        loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

    const [contributeModal, setContributeModal] = useState(false);
    const [msgModal, setMsgModal] = useState(false);
    const [formInputs, setFormInputs] = useState({
        e_id: loggedInEnterpriseId,
        c_level: '',
        market: '',
        market_unit: '',
        contribute: '',
        contribute_other: '',
        capability: '',
        capability_other: '',
        skill: ''
    });
    const [validateMsg, setValidateMsg] = useState('');
    const [submitMsg, setSubmitMsg] = useState('');
    const [filteredMarketUnit, setFilteredMarketUnit] = useState([]);
    const [filteredSkill, setFilteredSkill] = useState([]);
    const [containerDiv, setContainerDiv] = useState({height: '700px'});    
    const [mainDiv, setmainDiv] = useState({height: '610px'});    

    const careerLevel = ContributeData['career-level'].map((data)=>{
        return { value: data, label: data }
    });
    const marketData = ContributeData['market'].map((data)=>{
        return { value: data, label: data }
    });
    const contributeAsData = ContributeData['contribute'].map((data)=>{
        return { value: data, label: data }
    });
    const capabilityData = ContributeData['capability'].map((data)=>{
        return { value: data, label: data }
    });                                   
    
    const customStyles = {
        option: (provided, state) => ({
            ...provided,            
            fontSize: '13px',
            paddingTop: '2px'
        }),        
        menuList: (provided, state) => ({
            ...provided,           
            maxHeight: '150px'
        }),        
        control: (provided, state) => ({
            ...provided,
            minHeight: '33px',
            height: '33px'
        }),        
        singleValue: (provided, state) => ({
            ...provided,
            fontSize: '14px',
            color: 'black'
        }),
        input: (provided, state) => ({
            ...provided,
            fontSize: '14px',
            color: 'black'
        }),
        placeholder: (provided, state) => ({
            ...provided,
            fontSize: '14px',
            color: 'black'
        })        
    }       

    const handleOnChange = (name, value) => {                                                         
        setFormInputs(values => ({...values, [name]: value}))        
        setValidateMsg('')
        if(name === 'market'){                                                          
            setFilteredMarketUnit(ContributeData['market-unit'][value].map((data)=>{
                return { value: data, label: data }
            }));            
        }        
        else if(name === 'contribute' && value !== 'Other') {                
            if(mainDiv.height === '685px') setmainDiv({height: '610px'});
            else if(mainDiv.height === '760px') setmainDiv({height: '685px'});
            
            if(containerDiv.height === '775px') setContainerDiv({height: '700px'});
            else if(containerDiv.height === '850px') setContainerDiv({height: '775px'});
                        
            name = 'contribute_other';
            value = '';
            setFormInputs(values => ({...values, [name]: value}))                        
        }
        else if(name === 'contribute' && value === 'Other') {                                                
            if(mainDiv.height === '610px') setmainDiv({height: '685px'});
            else if(mainDiv.height === '685px') setmainDiv({height: '760px'});

            if(containerDiv.height === '700px') setContainerDiv({height: '775px'});
            else if(containerDiv.height === '775px') setContainerDiv({height: '850px'});
        }
        else if(name === 'capability' && value === 'Other') {                                                
            if(mainDiv.height === '610px') setmainDiv({height: '685px'});
            else if(mainDiv.height === '685px') setmainDiv({height: '760px'});

            if(containerDiv.height === '700px') setContainerDiv({height: '775px'});
            else if(containerDiv.height === '775px') setContainerDiv({height: '850px'});
        }                
        else if(name === 'capability' && value !== 'Other'){            
            if(mainDiv.height === '685px') setmainDiv({height: '610px'});
            else if(mainDiv.height === '760px') setmainDiv({height: '685px'});

            if(containerDiv.height === '775px') setContainerDiv({height: '700px'});
            else if(containerDiv.height === '850px') setContainerDiv({height: '775px'});

            setFilteredSkill(ContributeData['skill'][value].map((data)=>{
                return { value: data, label: data }
            }));
            let c_name = 'capability_other';
            let c_value = '';
            setFormInputs(values => ({...values, [c_name]: c_value}))                        
        }                    
    }    

    const handleContributeForm = (e) => {
        e.preventDefault();   
        if(process.env.NODE_ENV === 'development') {                                                            
            alert("Not allowed to Contribute in LKM from localhost.");
        }            
        else 
        {                               
            if(formInputs.c_level === '') {
                setValidateMsg('c_level');
                return false;
            }                        
            else if(formInputs.market === '') {
                setValidateMsg('market');
                return false;
            }                                    
            else if(formInputs.contribute === '') {
                setValidateMsg('contribute');
                return false;
            } 
            else if(formInputs.contribute === 'Other' && formInputs.contribute_other === '') {
                setValidateMsg('contribute');
                return false;
            }            

            var authOptions = {
                method: 'post',                                
                url: 'https://atci.lkm.accenture.com/lkm-apis/contribute',
                data: JSON.stringify(formInputs),
                headers: {
                    'Authorization': localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                 },
                json: true
            };
            axios(authOptions)
                .then((response) => {
                    setMsgModal(true);
                    setSubmitMsg(response.data.message);                    
                })
                .catch((error) => {
                    setSubmitMsg(error.data.message);
            })
        }        
    }

    return (
        <>
            <div className="main-container" id='main'>
                <title>LKM Portal - Contact</title>
                {/* <img src="images/contact/at-new-contact-banner-v2.png" alt="offerings banner" className='banner-img' /> */}
                <div className='bannerText-Wrapper'>
                <h1 className='bannerHeading' tabIndex={0}>Contact <span>Us</span></h1>
                <p className='bannerSubheading'>Connect with LKM for your requirements</p>
                </div>
            </div>
            <div className="banner-bar"></div>
            <div className="contact-container-bg">
                <Container className='stay-holder' maxWidth="xl">
                    <div className="learncard-container">
                        <div className="learncard-wrap">
                            <div className="learncard-row" id='request-for-training'>
                                <div className="learncard-box">
                                    <div className="learncard-imgzoom">
                                        <a href="#" aria-label="Coming Soon">
                                            <img src="images/contact/time-totrain-card.png" alt="" className='learncard-img' />
                                        </a>
                                    </div>
                                    {/* <h3>Request for Training</h3> */}
                                    <p>Log a lateral training request to fulfill the team's learning requirement <span style={{ visibility: 'hidden' }}>Technology, Delivery, and</span> </p>
                                    {/* <p><a href="https://lkmportal.atci.accenture.com/LMS/Need/RaiseTrainingRequest" target="_blank">Request for Training <img src="images/Offerings/Go Arrow.png" alt="" /></a></p> */}
                                    <p style={{fontFamily:"graphik-bold"}}>Coming soon...</p>
                                </div>
                            </div>
                            <div className="learncard-row" id="contribute-to-LKM">
                                <div className="learncard-box" >
                                    <div className="learncard-imgzoom">
                                        {/* <a onClick={()=> {setContributeModal(true);}}>
                                            <img src="images/contact/contribute-card.png" alt="eCatalog" className='learncard-img' />
                                        </a> */}
                                        <a href="#" aria-label="Coming Soon">
                                            <img src="images/contact/contribute-card.png" alt="" className='learncard-img' />
                                        </a>
                                    </div>
                                    {/* <h3>Contribute to LKM</h3> */}
                                    <p>Connect to contribute towards LKM initiatives as a facilitator, content SME, mentor, and speaker.</p>
                                    {/* <p><a href="#">Contribute to LKM <img src="images/Offerings/Go Arrow.png" alt="" /></a></p> */}
                                    {/* <p style={{fontFamily:"graphik-bold"}} className="contact-contribute-text" onClick={()=> {setContributeModal(true);document.querySelector("body").style.overflow = 'hidden';}}>Contribute to LKM <img className='contribute-icon' src="images/Offerings/Go Arrow.png" alt="" /></p> */}
                                    <p style={{fontFamily:"graphik-bold"}}>Coming soon...</p>
                                </div>
                            </div>
                            {contributeModal && <div className='c-lkm-bg-div'>
                                <div style={containerDiv}>                                
                                    <div className='c-lkm-main-div' style={mainDiv}>                                                                        
                                        <img src="images/contact/contribute_close_icon.png" alt="" className='c-lkm-close-icon' onClick={()=> {setContributeModal(false);document.querySelector("body").style.overflow = 'visible';}}/>
                                        <div className='c-lkm-bg-div-content'>
                                            <h3 className='c-lkm-h3'>I am interested to contribute to LKM learning initiatives</h3>                                                                            
                                        </div>                                    
                                        <div className='c-lkm-form-div'>
                                            <h5 className='c-lkm-h6'>Log a request to contribute to LKM by filling out this form</h5>                                        
                                            <form onSubmit={handleContributeForm} className='c-lkm-form'>                                            
                                                <div className='c-lkm-form-elem-div'>
                                                    <label className='c-lkm-single-label'>Enterprise Id </label>                                                    
                                                    <input className='c-lkm-single-input' value={loggedInEnterpriseId} disabled/>
                                                </div>
                                                <div className='c-lkm-form-elem-div'>
                                                    <label className='c-lkm-single-label'>Career Level <span className='mandatory-icon'>*</span>{validateMsg === 'c_level' && <span className='mandatory-msg'>(Required Field)</span>}</label>                                                                              
                                                    <Select options={careerLevel} styles={customStyles} onChange={(e)=>handleOnChange('c_level',e.value)} placeholder="select . . ."/>
                                                </div>                                                                                                  
                                                <div className='c-lkm-form-elem-div'>                                                
                                                    <label className='c-lkm-single-label'>Market <span className='mandatory-icon'>*</span>{validateMsg === 'market' && <span className='mandatory-msg'>(Required Field)</span>}</label>                                             
                                                    <Select options={marketData} styles={customStyles} onChange={(e)=> handleOnChange('market', e.value)} placeholder="select . . ." />
                                                </div>    
                                                <div className='c-lkm-form-elem-div'>
                                                    <label className='c-lkm-single-label'>Market Unit</label>                                                    
                                                    <Select options={filteredMarketUnit} styles={customStyles} onChange={(e)=> handleOnChange('market_unit', e.value)} placeholder="select . . ." />
                                                </div>                               
                                                <div className='c-lkm-form-elem-div'>
                                                    <label className='c-lkm-single-label'>I would like to contribute to LKM as <span className='mandatory-icon'>*</span>{validateMsg === 'contribute' && <span className='mandatory-msg'>(Required field)</span>}</label>                                                
                                                    <Select options={contributeAsData} styles={customStyles} onChange={(e)=> handleOnChange('contribute', e.value)} placeholder="select . . ." />
                                                </div>               
                                                {formInputs.contribute === 'Other' && <div className='c-lkm-form-elem-div'>
                                                    <label className='c-lkm-single-label c-lkm-other-input'>If any other, please specify</label>
                                                    <input className='c-lkm-single-input' value={formInputs.contribute_other || ''} onChange={(e)=> handleOnChange('contribute_other', e.target.value)}/>    
                                                </div>}                                                                                                                                   
                                                <div className='c-lkm-form-elem-div'>                                                
                                                    <label className='c-lkm-single-label'>Capability</label>                                                
                                                    <Select menuPlacement="top" options={capabilityData} styles={customStyles} onChange={(e)=> handleOnChange('capability', e.value)} placeholder="select . . ." />
                                                </div>    
                                                {formInputs.capability === 'Other' && <div className='c-lkm-form-elem-div'>
                                                    <label className='c-lkm-single-label c-lkm-other-input'>If any other, please specify</label>
                                                    <input className='c-lkm-double-input' onChange={(e)=> handleOnChange('capability_other', e.target.value)} value={formInputs.capability_other || ''}/>                                                
                                                </div>}
                                                <div className='c-lkm-form-elem-div'>
                                                    <label className='c-lkm-single-label'>Skill</label>                                                
                                                    <Select menuPlacement="top" options={filteredSkill} styles={customStyles} onChange={(e)=> handleOnChange('skill', e.value)} placeholder="select . . ." />
                                                </div>
                                                <div className='c-lkm-submit-div'>
                                                    <span><input type="submit" /></span>
                                                    <span className='mandatory-note'>[Fields marked with <span className='mandatory-aterick'>*</span> are mandatory]</span>                                                                                                        
                                                </div>                                            
                                            </form>                                                                                                                                                             
                                        </div>
                                    </div>
                                </div>                                
                            </div>}
                            {msgModal && <div className='c-lkm-msg-bg-div'>                                                                
                                    <div className='c-lkm-msg-div'>                                        
                                        <div className='c-lkm-submit-msg'>{submitMsg}</div>
                                        <div className='c-lkm-close-msg-btn-div'><button className='c-lkm-close-msg-btn' onClick={()=> {setMsgModal(false)}}>Ok</button></div>
                                    </div>
                            </div>}
                            <div className="learncard-row" id='request-for-content-creation'>
                                <div className="learncard-box" >
                                    <div className="learncard-imgzoom">
                                        <a href="https://ts.accenture.com/sites/LKMTools/LKMSurveys/23Sep21/LKM%20Content%20Design%20and%20Development/SitePages/Home.aspx" target="_blank">
                                            <img src="images/contact/create-content-card.png" alt="Events" className='learncard-img' />
                                        </a>
                                    </div>
                                    {/* <h3>Request for Content Creation</h3> */}
                                    <p>Raise a request to develop learning content for niche, customized requirements <span style={{ visibility: 'hidden' }}>Technology, </span></p>
                                    <p><a href="https://ts.accenture.com/sites/LKMTools/LKMSurveys/23Sep21/LKM%20Content%20Design%20and%20Development/SitePages/Home.aspx" target="_blank">Request for Content Creation <img src="images/Offerings/Go Arrow.png" alt="" /></a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}

export default Contact